import {insertScript} from '@optimaxdev/utils';

import {FUNCTIONAL_COOKIES} from 'constants/analytics';
import {REVIEWS_POPUPS_SRC} from 'constants/popupNames';
import {waitForActivatingCookieGroup} from 'features/oneTrust/oneTrust';
import {ReviewPopupsType} from 'types/reviewPopupsTypes';

/**
 * Prepare product purchased string for bizrate review popup on TYP
 * @returns {string} products inline
 */
function getProductString(orderDetails: ReviewPopupsType) {
    const productString = orderDetails.items.map(
        item => `URL=${item.product.urlPath}^SKU=${item.sku}^PRICE=${item.product.finalPrice}`,
    );
    return productString.join('|');
}

/**
 * Prepare data to set into window
 */
function setWindowData(orderDetails: ReviewPopupsType) {
    const {grandTotal, id, shippingAmount} = orderDetails;
    const products = getProductString(orderDetails);
    window.orderId = id;
    window.cartTotal = `${grandTotal} - ${shippingAmount}`;
    window.productPurchased = products || '';
}
/**
 * bizrate me on TYP
 */
export async function initBizrate(
    orderDetails: ReviewPopupsType,
    setIsPopupLoading?: (isLoading: boolean) => void,
) {
    await waitForActivatingCookieGroup(FUNCTIONAL_COOKIES);
    setWindowData(orderDetails);
    if (setIsPopupLoading) setIsPopupLoading(true);
    insertScript(
        REVIEWS_POPUPS_SRC.BIZRATE,
        true,
        () => setIsPopupLoading && setIsPopupLoading(false),
    );
}
